import Entity from "./Entity";

// Will be used later by the controllers
export default class Pawn extends Entity {}
